import axios from 'axios';
import CryptoJS from 'crypto-js';
import { BEBase } from '../constants/app.constant';
import { efefrg4rrrg323ffgfssw3e3ddadfw23 } from '../components/componentConst';

const SECRET_KEY = efefrg4rrrg323ffgfssw3e3ddadfw23;

// --- Axios Instance Setup ---
const apiClient = axios.create({
    baseURL: BEBase + "mle", // e.g., 'http://localhost:8000/api/mle/'
    headers: {
        'Content-Type': 'application/json',
    },
});

// --- Axios Request Interceptor ---
// This function will run before every request is sent.
apiClient.interceptors.request.use(
    (config) => {
        const encryptedCreds = localStorage.getItem('loginCred');
        // console.log(encryptedCreds)
        if (encryptedCreds) {
            try {
                const bytes = CryptoJS.AES.decrypt(encryptedCreds, SECRET_KEY);
                const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
                const decryptedCreds = JSON.parse(decryptedString);
                // console.log(decryptedCreds)

                if (decryptedCreds && decryptedCreds.token) {
                    // If a token exists, add it to the request headers
                    config.headers['Authorization'] = `Token ${decryptedCreds.token}`;
                }
            } catch (error) {
                console.error('Decryption error in interceptor:', error);
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


// --- API Functions ---
// No longer need to manually add headers to each function call.

// ============================
// Blog Post APIs
// ============================
export const blogApi = {
    /**
     * Fetches a list of blog posts. Publicly accessible.
     * @param {object} params - Query parameters (e.g., { page: 1, search: 'finance', category__slug: 'tech' })
     */
    list: (params) => apiClient.get('/blogs/', { params }),

    /**
     * Fetches a single blog post by its ID. Publicly accessible.
     * @param {number} id - The ID of the blog post.
     */
    get: (id) => apiClient.get(`/blogs/${id}/`),

    /**
     * Creates a new blog post. Admin only.
     * @param {object} blogData - The data for the new blog post.
     */
    create: (blogFormData) => apiClient.post('/blogs/', blogFormData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    }),

    /**
     * Updates an existing blog post. Admin only.
     * @param {number} id - The ID of the blog post to update.
     * @param {object} blogData - The updated data.
     */
    update: (id, blogData) => apiClient.put(`/blogs/${id}/`, blogData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    },),

    /**
     * Deletes a blog post. Admin only.
     * @param {number} id - The ID of the blog post to delete.
     */
    delete: (id) => apiClient.delete(`/blogs/${id}/`),
};


// ============================
// Category APIs
// ============================
export const categoryApi = {
    /**
     * Fetches a list of all categories.
     */
    list: () => apiClient.get('/categories/'),

    /**
     * Creates a new category. Admin only.
     * @param {object} categoryData - e.g., { name: 'New Category', slug: 'new-category' }
     */
    create: (categoryData) => apiClient.post('/categories/', categoryData),

    /**
     * Updates an existing category. Admin only.
     * @param {number} id - The ID of the category to update.
     * @param {object} categoryData - The updated data.
     */
    update: (id, categoryData) => apiClient.put(`/categories/${id}/`, categoryData),

    /**
     * Deletes a category. Admin only.
     * @param {number} id - The ID of the category to delete.
     */
    delete: (id) => apiClient.delete(`/categories/${id}/`),
};


// ============================
// Contact Submission APIs
// ============================
export const contactApi = {
    /**
     * Creates a new contact submission. Publicly accessible.
     * @param {object} contactData - { name, email, phone, message }
     */
    create: (contactData) => apiClient.post('/contacts/', contactData),

    /**
     * Fetches a list of all contact submissions. Admin only.
     * @param {object} params - Query parameters (e.g., { page: 1 })
     */
    list: (params) => apiClient.get('/contacts/', { params }),

    /**
     * Updates a contact submission (e.g., to change status). Admin only.
     * @param {number} id - The ID of the submission to update.
     * @param {object} contactData - The updated data, e.g., { status: 'CON' }
     */
    update: (id, contactData) => apiClient.patch(`/contacts/${id}/`, contactData),

    /**
     * Deletes a contact submission. Admin only.
     * @param {number} id - The ID of the submission to delete.
     */
    delete: (id) => apiClient.delete(`/contacts/${id}/`),
};

// ============================
// LAMF (Loan Against Mutual Funds) APIs
// ============================
export const lamfApi = {
    /**
     * Create a new LAMF application (publicly accessible).
     * payload: { intent: "LOAN_APPLICATION", lender: "bajaj_finserv" }
     */
    create: (lamfData) => apiClient.post('/lamf/', lamfData),

    /**
     * Fetch list of all LAMF applications (backend currently open, no auth).
     */
    list: (params) => apiClient.get('/lamf/', { params }),

    /**
     * Fetch single LAMF record by ID.
     */
    get: (id) => apiClient.get(`/lamf/${id}/`),

    /**
     * Update a LAMF record (if needed).
     */
    update: (id, lamfData) => apiClient.patch(`/lamf/${id}/`, lamfData),

    /**
     * Delete a LAMF application by ID.
     */
    delete: (id) => apiClient.delete(`/lamf/${id}/`),
};
